module.exports = __webpack_public_path__ + "static/media/cardAttachment.eb9c2edc.svg";